import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  avatarDeleteStatus: null,
  updatePasswordStatus: null,

  telegram: '',
  unsubscribeTgStatus: null,
}

export const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    setAvatarDeleteStatus: (state, action) => { state.avatarDeleteStatus = action.payload },
    setUpdatePasswordStatus: (state, action) => { state.updatePasswordStatus = action.payload },

    setProfileTg: (state, action) => { state.telegram = action.payload },
    setProfileUnsubscribeTgStatus: (state, action) => { state.unsubscribeTgStatus = action.payload },

    resetProfile: () => initialState,
  },
})

export const {

  setAvatarDeleteStatus,
  setUpdatePasswordStatus,

  setProfileTg,
  setProfileUnsubscribeTgStatus,

  resetProfile,
} = profileSlice.actions

export default profileSlice.reducer
